module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/assistenzaclienti/assistenzaclienti.component.scss
// module id = ./src/app/assistenzaclienti/assistenzaclienti.component.scss
// module chunks = main